import React from 'react'
import MicroFrontend from "../MicroFrontend"

const DuplicateNewsLetterWidget = ({ history, data }) => {
    return <MicroFrontend
        history={history}
        data={data}
        name="DuplicateNewsLetterWidget"
    />
}

export default (DuplicateNewsLetterWidget);